<script lang="ts">
  import { router } from "../src/router";
  import { createEventDispatcher, getContext } from "svelte";
  import { RequestBuilder } from "@lernetz/request";
  import type { RouteNode } from "../src/route";
  import { active as activeAction } from "../src/actions";

  export let to: string;
  export let active: string = ""; // deprecated
  export let classActive: string = active;
  export let classInactive: string = "";
  export let exact: boolean = false;
  export let query: Record<string, string> = undefined;
  export let hash: string = undefined;
  export let restoreScroll: boolean = false;

  let route = getContext("route") as RouteNode;
  let path: string;
  let href: string;
  let dispatcher = createEventDispatcher<{ click: MouseEvent }>();

  $: {
    // check if path starts with /, its absolute path
    if (to.startsWith("/")) route = undefined;

    // generate path based on parent
    path = route ? route.generatePath(to) : to;

    // sanitize path and apply ../ ./
    path = new RequestBuilder(path).url;
  }

  // generate full href based on router mode
  $: href = router.generateURL(path, { query: new URLSearchParams(query), hash });

  function handler(event: MouseEvent) {
    router.goto(path, { query: new URLSearchParams(query), hash, restoreScroll });
    event.preventDefault();
    dispatcher("click", event);
  }
</script>

<a
  {...$$restProps}
  use:activeAction={{ classActive, classInactive, exact, path }}
  on:click={handler}
  {href}
>
  <slot />
</a>
